import { Component, Host, h, Event, Prop, State } from "@stencil/core";
import type { EventEmitter } from "@stencil/core"

import { EMPTY_INPUT_MESSAGE,
    LONG_INPUT_MESSAGE,
    INPUT_MAX_LENGTH ,INPUT_PLACEHOLDER } from "../../../global/variables";

@Component({
    tag: "leichte-sprache-free-text",
    styleUrl: "leichte-sprache-free-text.scss",
})
export class LeichteSpracheFreeText {
    inputElement: HTMLInputElement;
    @Event() freeText: EventEmitter<string>;
    @State() emptyUserInput = false;
    @State() longUserInput = false;
    @State() infoMessage: string;
    @Prop() disabled = false;

    handleKeyUp(e: any) {
        if (e.key === "Enter") {
            this.processInput();
        } else if (this.emptyUserInput) {
            this.emptyUserInput = false;
            this.infoMessage = "";
        }
    }

    handleButtonClick() {
        this.processInput();
    }

    // Check if the user input is too long (live check)
    validateInput() {
        const input = this.inputElement.value;
        const maxLength = INPUT_MAX_LENGTH;
        if (input.length > maxLength) {
            this.emptyUserInput = false;
            this.longUserInput = true;
            this.infoMessage = LONG_INPUT_MESSAGE;
        } else if (this.longUserInput) {
            this.longUserInput = false;
            this.infoMessage = "";
        }
    }

    processInput() {
        if (this.longUserInput) {
            this.inputElement.focus();
            return;
        }
        // Check if the message is not empty before sending it to the bot
        this.inputElement.value = this.inputElement.value.trim();
        if (this.inputElement.value.length === 0) {
            this.emptyUserInput = true;
            this.infoMessage = EMPTY_INPUT_MESSAGE;
            this.inputElement.focus();
            return;
        }
        this.emitValue();
        this.resetInput();
    }

    emitValue() {
        this.freeText.emit(this.inputElement.value);
    }

    resetInput() {
        this.inputElement.value = "";
    }

    handleSubmit(e: any) {
        e.preventDefault();
    }

    render() {
        return (
            // Class .disabled has a naming clash with BA CSS on IE and Edge,
            // on which Shadow DOM does not work. so I named it is-disabled instead
            <Host class={this.disabled ? "is-disabled" : ""}>
                <form onSubmit={(e) => this.handleSubmit(e)}>
                    <input
                        autofocus
                        aria-label="Nachricht eingeben"
                        aria-controls="ls-conversation"
                        title="Nachricht eingeben"
                        autocomplete="off"
                        disabled={this.disabled}
                        ref={(el: HTMLInputElement) => {
                            this.inputElement = el;
                            this.inputElement.focus();
                        }}
                        onInput={this.validateInput.bind(this)}
                        onKeyUp={this.handleKeyUp.bind(this)}
                        placeholder={this.disabled ? "" : INPUT_PLACEHOLDER}
                        maxlength="150"
                    />
                    <button
                        type="submit"
                        title="Nachricht absenden"
                        aria-label="Nachricht absenden"
                        disabled={this.disabled}
                        onClick={this.handleButtonClick.bind(this)}
                    >
                        <i aria-hidden="true" class="ba-icon ba-icon-chevron-right"/>
                    </button>
                </form>
            </Host>
        );
    }
}
